<template>
    <div
        v-loading.fullscreen.lock="loading"
        class="purchase-meeting"
    >
        <div class="content">
            <div class="top-box">
                <div class="title mb50">{{ $t('采购对接会') }}</div>
                <el-row
                    class="tags flex fw"
                    :gutter="0"
                >
                    <el-col
                        class="tag-item"
                        :sm="8"
                        :xs="24"
                    >
                        <div class="item-box">
                            <i class="el-icon-circle-check"></i>
                            <span>{{ $t('零成本') }}</span>
                        </div>
                    </el-col>
                    <el-col
                        class="tag-item"
                        :sm="8"
                        :xs="24"
                    >
                        <div class="item-box">
                            <i class="el-icon-circle-check"></i>
                            <span>{{ $t('定制') }}</span>
                        </div>
                    </el-col>
                    <el-col
                        class="tag-item"
                        :sm="8"
                        :xs="24"
                    >
                        <div class="item-box">
                            <i class="el-icon-circle-check"></i>
                            <span>{{ $t('有效') }}</span>
                        </div>
                    </el-col>
                </el-row>
                <div class="desc mb50">{{ $t('对接会描述') }}</div>
                <div class="hint-box flex fc align-center fd">
                    <el-button
                        type="primary"
                        class="btn-meeting"
                        round
                        @click="location"
                    >{{ $t('对接会会议按钮') }}
                    </el-button>
                </div>
            </div>
            <el-row
                class="login-box flex align-center fc fw"
                :gutter="20"
            >
                <el-col :span="1.5">
                    <div class="title mb10">{{ $t('采购对接会') }}</div>
                </el-col>
            </el-row>
            <div class="form-box flex fd align-center ">
                <el-form
                    ref="form"
                    class="register-form"
                    :model="form"
                    label-position="top"
                    label-width="100px"
                    :rules="rules"
                    :size="formSize"
                    @submit.native.prevent
                    @keyup.enter.native="submit"
                >
                    <div class="sub-title">{{ $t('采购者信息') }}</div>
                    <el-row
                        :gutter="20"
                        class="flex fw align-start "
                    >
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="companyName"
                                :label="$t('公司名称')"
                            >
                                <el-input
                                    v-model="form.companyName"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="businessNature"
                                :label="$t('公司性质')"
                            >
                                <el-input
                                    v-model="form.businessNature"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="email"
                                :label="$t('邮箱')"
                            >
                                <el-input
                                    v-model="form.email"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="website"
                                :label="$t('网址')"
                            >
                                <el-input
                                    v-model="form.website"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="name"
                                :label="$t('姓名')"
                            >
                                <el-input
                                    v-model="form.name"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="mobile"
                                :label="$t('联系电话')"
                            >
                                <el-input
                                    v-model="form.mobile"
                                    maxlength="11"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div
                        id="productDetails"
                        class="sub-title"
                    >
                        {{ $t('产品详情') }}
                    </div>
                    <el-row :gutter="20">
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item prop="answerIds">
                                <template slot="label">
                                    <div class="label iflex align-start">
                                        <div class="form-item-label nowrap mr20">
                                            {{ $t('产品标签') }}
                                        </div>
                                        <!-- <span class="form-item-desc wrap red">{{ $t('最多选择', { num: 3 }) }}</span> -->
                                    </div>
                                </template>
                                <el-button
                                    type="primary"
                                    @click="showProductTree = true"
                                >{{ $t('请选择') }}
                                </el-button>
                                <div class="tags-list margin-t-12">
                                    <el-tag
                                        v-for="tag in productNodes"
                                        :key="tag.aliasName"
                                        closable
                                        type="primary"
                                        class="mt20"
                                        effect="plain"
                                        @close="tagClose(tag)"
                                    >
                                        {{ tag.aliasName }}
                                    </el-tag>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24">
                            <el-form-item prop="productImg">
                                <template slot="label">
                                    <div class="label iflex align-start">
                                        <div class="form-item-label nowrap mr20">
                                            {{ $t('产品图片') }}
                                        </div>
                                        <span class="form-item-desc wrap">
                                            {{
                                                $t('图片为', {
                                                    resolving: '400*400',
                                                    size: 2,
                                                    type: 'PNG、JPG',
                                                    num: 3
                                                })
                                            }}
                                        </span>
                                    </div>
                                </template>
                                <div class="content flex ">
                                    <v-base-upload
                                        accept=".jpeg,.jpg,.png"
                                        list-type="picture-card"
                                        :file-data.sync="form.productImg"
                                        :limit="3"
                                        :size="2"
                                        :resolving="[400,400]"
                                    />
                                    <!-- @callBackUploadInfo="getUploadInfo"
                                        @delete="uploadDelete" -->
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="certificates"
                                :label="$t('证书')"
                            >
                                <el-input
                                    v-model="form.certificates"
                                    :placeholder="$t('请输入')"
                                    maxlength="100"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-row :gutter="10">
                                <el-col
                                    :md="20"
                                    :xs="24"
                                >
                                    <el-form-item
                                        prop="purchaseQuantity"
                                        :label="$t('数量')"
                                    >
                                        <el-input
                                            v-model="form.purchaseQuantity"
                                            maxlength="10"
                                            :placeholder="$t('请输入')"
                                        />
                                    </el-form-item>
                                </el-col>
                                <el-col
                                    v-if="form.purchaseQuantity"
                                    :md="4"
                                    :xs="24"
                                >
                                    <el-form-item
                                        prop="unit"
                                        :label="$t('单位')"
                                    >
                                        <el-input
                                            v-model.trim="form.unit"
                                            maxlength="5"
                                            :placeholder="$t('单位')"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <div class="sub-title">{{ $t('供应商需求') }}</div>
                    <el-row
                        :gutter="20"
                        class="flex fw align-start "
                    >
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="suppliersBusinessNature"
                                :label="$t('供应商性质')"
                            >
                                <v-base-cascader
                                    style="width:100%"
                                    :data="form.suppliersBusinessNature"
                                    :data-list="natureList"
                                    :cascader-props="{
                                        label: 'aliasName',
                                        value: 'aliasName',
                                        children: 'answerList',
                                        emitPath: false,
                                        multiple: false
                                    }"
                                    :show-all-levels="false"
                                    :collapse-tags="false"
                                    @change="handleBusinessNatureChange"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="suppliersScale"
                                :label="$t('公司规模')"
                            >
                                <el-input
                                    v-model="form.suppliersScale"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="suppliersRegion"
                                :label="$t('区域')"
                            >
                                <el-input
                                    v-model="form.suppliersRegion"
                                    maxlength="100"
                                    :placeholder="$t('请输入')"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24">
                            <el-form-item
                                prop="other"
                                :label="$t('其他')"
                            >
                                <el-input
                                    v-model="form.other"
                                    maxlength="500"
                                    :placeholder="$t('请输入')"
                                    type="textarea"
                                    show-word-limit
                                    :autosize="{ minRows: 5 }"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="sub-title">{{ $t('预约时间') }}</div>
                    <el-row :gutter="20">
                        <el-col
                            :sm="12"
                            :xs="24"
                        >
                            <el-form-item
                                prop="expectedDate"
                                :label="$t('预约时间')"
                            >
                                <el-date-picker
                                    style="width:100%"
                                    v-model="form.expectedDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :placeholder="$t('选择日期')"
                                    :picker-options="pickerOptions"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-button
                    type="primary"
                    class="btn-submit mt50"
                    :loading="isSubmit"
                    round
                    @click="submit"
                >{{ $t('提交') }}
                </el-button>
            </div>
            <div class="bottom-box">
                <img
                    src="@/assets/img/purchaseMeeting/purchaseMeeting_bottom.jpg"
                    alt=""
                    class="mt40 mb40 img-responsive"
                >
            </div>
        </div>
        <el-dialog
            :title="$t('请选择')"
            :visible.sync="showProductTree"
            :close-on-click-modal="false"
            custom-class="product-tree"
            width="500px"
        >
            <el-input
                v-model="treeKeyword"
                class="mb20"
                :placeholder="$t('关键字搜索')"
                size="small"
            />
            <el-tree
                ref="tree"
                :data="productList"
                show-checkbox
                node-key="id"
                :check-strictly="true"
                :check-on-click-node="true"
                accordion
                :filter-node-method="filterTreeNode"
                :default-expanded-keys="form.answerIds"
                :props="{
                    label: 'aliasName',
                    children: 'answerList',
                    disabled:'disabled',
                    isLeaf:'leaf'
                }"
                @check="treeChange"
            />
        </el-dialog>
    </div>
</template>
<script>
import BaseUpload from '@/components/Common/BaseUpload'
import BaseCascader from '@/components/Common/BaseCascader'
// import { merchant, purchase, common } from '@/api'

import { getProductTags, saveVisitorNeeds } from '@/api'
import { mapGetters } from 'vuex'
// import head from '@/mixins/head'

export default {
    components: {
        'v-base-cascader': BaseCascader,
        'v-base-upload': BaseUpload
    },
    data() {
        return {
            count: 1, // 计数
            showProductTree: false,
            treeKeyword: '', // 树关键字
            formSize: 'small',
            loading: false,
            isSubmit: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < new Date().getTime() - 86400000
                }
            },
            form: {},
            tableData: [], // 产品列表
            productNodes: [], // 产品节点
            natureList: [], // 公司性质列表
            rules: {
                companyName: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                businessNature: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExEmail'
                    }
                ],
                name: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                mobile: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExPhone1'
                    }
                ],
                answerIds: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'change',
                        regType: 'ExArray'
                    }
                ],
                productImg: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'change'
                    }
                ],
                unit: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExCnEn'
                    }
                ],
                website: [
                    {
                        validator: this.validateRules,
                        required: false,
                        trigger: 'blur',
                        regType: 'ExDomain'
                    }
                ],
                purchaseQuantity: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExNum'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapGetters([ 'isLogin', 'subjectType', 'userInfo' ]),
        productList() {
            return JSON.parse(JSON.stringify(this.tableData))
        },
        answerIds() {
            return JSON.parse(JSON.stringify(this.form.answerIds ?? []))
        }
    },
    watch: {
        'form.productPhotos'() {
            this.$refs.form.validateField('productPhotos')
        },
        treeKeyword(val) {
            this.$refs.tree.filter(val)
        },
        answerIds(val, oldVal = []) {
            // 整体选3个
            // if (val.length >= 3) {
            //     this.setItemDisabled(
            //         JSON.parse(JSON.stringify(this.productList)),
            //         false
            //     )
            // } else if (oldVal.length === 3 && val.length < 3) {
            //     this.setItemDisabled(
            //         JSON.parse(JSON.stringify(this.productList)),
            //         true
            //     )
            //     this.$refs.tree.setCheckedKeys(val)
            // }
            // 产品类别最多选3个，其他不限制
            const arr = []
            if (this.productList.length > 0) {
                arr.push(this.productList[0])
                const list = []
                if (this.productNodes.length > 0) {
                    for (const i in this.productNodes) {
                        if (
                            this.productNodes[i].questionId ===
                            '20111baoliqiuji' ||
                            this.productNodes[i].questionId === '2011baoliqiuji'
                        ) {
                            list.push(this.productNodes[i].id)
                        }
                    }
                }
                if (list.length >= 3) {
                    this.setItemDisabled(JSON.parse(JSON.stringify(arr)), false)
                } else {
                    this.setItemDisabled(JSON.parse(JSON.stringify(arr)), true)
                    this.$refs.tree.setCheckedKeys(val)
                }
            }
        }
    },
    created() {
    },
	async mounted() {
        this.initForm()
        // await this.appLogin()
        await this.getProductTags()
    },
    methods: {
        // app登录
        // async appLogin() {
        //     const token = decodeURIComponent(this.$route.query.t)

        //     if (token && token !== 'undefined') {
        //         this.$store.commit('user/SET_TOKEN', token)
        //         await this.$store.dispatch('user/GetUserLoginInfo')
        //     }
        // },
        // 初始化表单
        initForm() {

            let userInfo
console.log(this.userInfo, 'this.userInfo')
            if (this.subjectType == 'VISITOR') {
                userInfo = this.userInfo?.visitor
            }

            if (userInfo) {
                this.form = {
                    companyName: userInfo?.corporateName || undefined, // 公司名称
                    email: userInfo?.email || undefined, // 邮箱
                    website: userInfo?.website || undefined, // 网址
                    name: userInfo?.name || undefined, // 名称
                    mobile: userInfo?.mobile || undefined, // 电话
                    businessNature: undefined, // 商业性质
                    answerIds: [], // 答案集合
                    productPhotos: [], // 产品图片
                    productImg: '',
                    certificates: undefined, // 证书
                    purchaseQuantity: undefined, // 数量
                    unit: undefined, // 单位
                    suppliersScale: undefined, // 规模
                    suppliersRegion: undefined, // 区域
                    suppliersBusinessNature: undefined,
                    other: undefined, // 其他
                    expectedDate: undefined, // 预计日期
                    source: this.$route.query.fromUrl ?? ''// 来源
                }

                this.$nextTick(() => {
                    this.$refs.form.clearValidate()
                })
            }
        },
        // 获取产品标签
        async getProductTags() {
            this.loading = true
            const res = await getProductTags({
                showType: 'PRODUCT_LIST',
                copySubAnswer: true
            })
            console.log('res--->', res)
            if (res.data.code == 1000) {
                const questionList = res.data.data.questionList

                // const productList = questionList.filter(
                //     item =>
                //         item.id === '2011baoliqiuji' ||
                //         // item.id === '2012baoliqiuji' ||
                //         item.id === '20111baoliqiuji'
                //     //  ||
                //     // item.id === '20121baoliqiuji'
                // )

                this.tableData = this.initProductData(questionList)
            }

			const res_actor = await getProductTags({
				showType: 'ACTOR_LIST',
                copySubAnswer: true
			})
            if (res_actor.data.code == 1000) {
                const questionList = res_actor.data.data.questionList

                // this.natureList = questionList.filter(
                //     item =>
                //         item.id === '2001baoliqiuji' ||
                //         item.id === '20011baoliqiuji'
                // )
                this.natureList = questionList

                console.log('this.natureList--->', this.natureList)
            }
            this.loading = false
        },
        refresh(resolve) {
        },
        // 初始化产品数据
        initProductData(list) {
            return list.map((data) => {
                if (data.leaf) {
                    data.disabled = false
                } else {
                    data.disabled = true
                }

                if (data.answerList?.length) {
                    this.initProductData(data.answerList)
                }
                return data
            })
        },
        // 设置禁用状态
        setItemDisabled(list, init) {
            list.forEach((v) => {
                if (init) {
                    if (v.leaf) {
                        v.disabled = false
                    } else {
                        v.disabled = true
                    }
                    this.setItemDisabled(v.answerList ?? [], init)
                } else if (!this.answerIds.includes(v.id)) {
                    v.disabled = true
                    if (v.answerList?.length) {
                        this.setItemDisabled(v.answerList ?? [], init)
                    }
                } else {
                    v.disabled = false
                }
                this.$refs.tree.updateKeyChildren(v.id, v.answerList ?? [])
            })
        },
        // 更改商业性质
        handleBusinessNatureChange(data) {
            if (data && Object.keys(data).length) {
                this.form.suppliersBusinessNature = data?.nodes[0]?.label
            }
        },
        // 获取上传图片信息
        getUploadInfo(data) {
            this.form.productPhotos.push(data)
            this.setProductImgs()
        },
        // 删除上传
        uploadDelete(file) {
            if (file) {
                this.form.productPhotos = this.form.productPhotos.filter(
                    item => item.uid !== file.uid
                )
                this.setProductImgs()
            }
        },
        // 设置产品图片
        setProductImgs() {
            this.form.productImg = this.form.productPhotos
                .map((v) => {
                    return v.url
                })
                .join(',')
        },
        // 提交
        submit() {
            /* if (!this.isLogin || this.ident !== 'v') {
                this.$notify({
                    type: 'error',
                    title: this.$t('登录观众后才能发起需求')
                })
                return
            } */
            console.log(this, '------------')
            console.log('this.form---->', this.$refs.form)
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    console.log('已完善---->', this.form)
                } else {
                    console.log('未完善')
                }
             })
            this.$refs.form.validate(async(valid) => {
                if (valid) {
                    this.isSubmit = true
                    // await this.$axios.post(
                    //     purchase.submitVistor,
                    //     this.form,
                    //     true
                    // )
                    await saveVisitorNeeds(this.form).then((res) => {
                        if (res.data.data) {
                            this.$notify({
                                message: this.$t('tip.success'),
                                type: 'success'
                            })
                        }
                    })
                    if (this.count === 1) {
                        this.count += 1
                        this.$alert(
                            this.$t('提交下一条采购信息'),
                            this.$t('提示'),
                            {
                                confirmButtonText: this.$t('确定'),
                                callback: () => {
                                    this.afterSubmit()
                                }
                            }
                        )
                    } else {
                        this.afterSubmit()
                    }
                }
            })
        },
        // 定位表单
        location() {
            this.$nextTick(() => {
                this.$el
                    .querySelector('.form-box #productDetails')
                    .scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    })
            })
        },
        // 提交后处理
        afterSubmit() {
            this.form.answerIds = []
            this.form.productPhotos = []
            this.form.productImg = ''
            this.form.certificates = undefined
            this.form.purchaseQuantity = undefined
            this.form.unit = undefined
            this.isSubmit = false
            this.productNodes = []
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.$refs.tree.setCheckedKeys([])

                this.location()
            })
        },
        // 过滤关键字
        filterTreeNode(value, data) {
            if (!value) return true
            return data.aliasName.includes(value)
        },
        // 树节点选中
        treeChange(data, nodes) {
            this.form.answerIds = nodes.checkedKeys
            this.productNodes = nodes.checkedNodes

            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(nodes.checkedKeys)
            })
        },
        // 关闭标签
        tagClose(tag) {
            const index = this.productNodes.findIndex(
                item => item.id === tag.id
            )
            this.productNodes.splice(index, 1)
            this.form.answerIds.splice(index, 1)
        }
    }
}
</script>
<style lang="stylus" scoped>
.purchase-meeting {
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    ::v-deep .el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
        display: inline-block !important;
    }

    ::v-deep .el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
        display: none !important;
    }

    .content {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 10px;

        .login-box {
            padding: 50px 0 40px;
            border-bottom: 1px solid #cccccc;

            .title {
                font-weight: bold;
                font-size: 32px;
                color: $color-main;
            }

            .desc {
                color: $color-main;
            }

            .btn-login {
                width: 200px;
            }
        }

        .date-box {
            padding-top: 40px;
            line-height: 2;
            color: $color-main;
        }

        .form-box {
            border-bottom: 1px solid #cccccc;
            padding-bottom: 50px;

            .sub-title {
                color: $color-main;
                // @include border_color("primary", "all");
                font-size: 30px;
                font-weight: bold;
                line-height: 50px;
                border-left: 5px solid;
                padding: 0 20px;
                margin: 30px 0;
            }

            .label {
                .form-item-label {
                }

                .form-item-desc {
                    font-size: 12px;
                    //@include font_color("");
                }
            }
        }

        .top-box {
            padding: 50px 0;

            .title {
                color: $color-main;
                font-size: 48px;
                text-align: center;
            }

            .tags {
                padding: 15px 0;
                background: $color-main;

                .tag-item {
                    display: flex;
                    justify-content: center;

                    .item-box {
                        width: 180px;
                        line-height: 2;

                        i {
                            color: $color-white;
                            font-size: 26px;
                            margin-right: 5px;
                        }

                        span {
                            color: $color-white;
                            font-size: 26px;
                        }
                    }
                }
            }

            .desc {
                color: $color-black-65;
                background: $color-main-hover;
                font-size: 20px;
                line-height: 1.5;
                padding: 40px;
                text-align: justify;
            }

            .hint-box {
                .hint {
                    margin-bottom: 40px;

                    i {
                        color: $color-main;
                        font-size: 20px;
                    }

                    span {
                        color: $color-black-65;
                        font-size: 20px;
                    }
                }
            }
        }
    }

    .btn-meeting,
    .btn-submit {
        font-size: 18px;
        padding-left: 40px;
        padding-right: 40px;
    }

    .product-tree {
        .el-tree {
            height: 500px;
            overflow-y: auto;
        }
    }
}
</style>
